import apiClient from '../utils/apiService';

/**
 * 工单模块 API
 */
export const workOrderApi = {
  // 上传图片，返回 OSS URL
  uploadImage: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return apiClient.post('/work-order/upload-image', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  // 创建工单
  create: (data) => apiClient.post('/work-order/create', data),

  // 更新工单
  update: (data) => apiClient.put('/work-order/update', data),

  // 删除工单
  delete: (id) => apiClient.delete(`/work-order/delete/${id}`),

  // 分页查询
  page: (params) => apiClient.post('/work-order/page', params),

  // 仪表盘
  dashboard: () => apiClient.get('/work-order/dashboard'),

  // 加急处理
  urgent: (id) => apiClient.post(`/work-order/urgent/${id}`),
};

export default workOrderApi;
